import { combineReducers } from '@reduxjs/toolkit'

import { reducer as userTreatmentId } from './userTreatmentId'

export default combineReducers({ userTreatmentId })
